module.exports = __webpack_public_path__ + "static/media/adeola-logo.97dbdbfc.svg";